import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import type { WorkflowConfig } from './config';

/** The enabled workflow catalog (server-configured, editable by Site Admins). */
export function useWorkflows() {
  return useQuery({
    queryKey: ['workflows'],
    queryFn: () => api.get<WorkflowConfig[]>('/workflows'),
    staleTime: 5 * 60 * 1000,
  });
}
